import React from 'react';
import './Card.css';

const Card = ({ person }) => {
  const sectors = person?.sectors || ['ai fundamentals', 'automotive', 'generative ai'];

  return <div className="card">
    {
      person.photoUrl ? <img className="card-photo" src={person.photoUrl} alt={person.firstName || "Person"} /> : <div className='card-photo' />
    }

    <div className="card-info">
      <h4>{person.firstName + ' ' + person.lastName}</h4>
      <p className="position">
        {person.jobTitle} <br />
        <b>{person.organization}</b>
      </p>
      <p className="sectors">{sectors.join(' / ')}</p>
    </div>
  </div>;
};

export default Card;
